import { render, staticRenderFns } from "./CredorParametro.vue?vue&type=template&id=2d6073a8"
import script from "./CredorParametro.vue?vue&type=script&lang=js"
export * from "./CredorParametro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports